import {
  Entity,
  type EntityFields,
  type EntityRecord,
  Fields,
} from '@burnsred/entity';
import DuckAuth from '@burnsred/entity-duck-namespace-auth';

import { duckAppName } from '@/constants';
import { settings } from '@/settings';

/**
 * Note: this entity can only check whoami;
 * to modify User, create an entity that extends DjangoRestFramework
 */
class WhoamiEntity extends Entity {
  static idField = 'id';

  static paginated = false;

  static paths = {
    apiBase: settings.AUTH_PATHNAME,
  };

  static fields: EntityFields<WhoamiEntityFields> = {
    id: new Fields.IdField({ readOnly: true }),
    uuid: new Fields.CharField({ readOnly: true, blank: true }),
    email: new Fields.CharField({ readOnly: true, blank: true }),
    first_name: new Fields.CharField({ readOnly: true, blank: true }),
    last_name: new Fields.CharField({ readOnly: true, blank: true }),
    full_name: new Fields.CharField({ readOnly: true, blank: true }),
    is_active: new Fields.BooleanField({ readOnly: true, blank: true }),
    is_staff: new Fields.BooleanField({ readOnly: true, blank: true }),
    is_superuser: new Fields.BooleanField({ readOnly: true, blank: true }),
  };

  static dataToRecord(data?: Partial<WhoamiEntityFields>) {
    let record = super.dataToRecord({});
    try {
      record = super.dataToRecord(data);
    } catch (error) {
      console.error('dataToRecord', { data, error });
    }
    return record as WhoamiEntityRecord;
  }
}

export type WhoamiEntityFields = {
  id: string;
  uuid: string;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  is_active: boolean;
  is_staff: boolean;
  is_superuser: boolean;
};

export type WhoamiEntityRecord = EntityRecord<WhoamiEntityFields>;

WhoamiEntity.duck = new DuckAuth({
  app: duckAppName,
  entity: WhoamiEntity,
  name: 'WhoamiEntity',
});

export default WhoamiEntity;
